import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import relativeTime from "dayjs/plugin/relativeTime";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import customParseFormat from "dayjs/plugin/customParseFormat";
import quarterOfYear from "dayjs/plugin/quarterOfYear";
import "dayjs/locale/ar";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(relativeTime);
dayjs.extend(isSameOrBefore);
dayjs.extend(customParseFormat);
dayjs.extend(quarterOfYear);

// Persisted timestamps (sellDate, createdAt, ...) are stored as UTC wall-clock
// values but the API echoes them back WITHOUT a timezone suffix, so a plain
// dayjs(value) parses the UTC digits as if they were local and shows the wrong
// clock (e.g. a 7:00 PM UTC+6 sale renders as 12:59 PM). Render stored
// timestamps through toLocal() so the UTC instant is converted to the viewer's
// local zone. Robust whether or not the string carries a trailing "Z".
// The business's fixed timezone (IANA, e.g. "Asia/Kuwait"), set once from company
// settings via setStoreTimeZone(). While unset, timestamps fall back to the viewer's
// device zone (the previous behavior), so there is zero change until it's configured.
let _storeTz = null;
export const setStoreTimeZone = (tz) => {
  _storeTz = tz || null;
};

// The timezone to send to the backend for server-rendered date filtering / report PDFs:
// the configured store zone if set, else the device's own IANA zone.
export const storeTimeZone = () => _storeTz || dayjs.tz.guess();

// Render a stored UTC timestamp in a FIXED business timezone, independent of the viewing
// device. Pass an explicit tzId, or omit it to use the app-wide store timezone. Falls back
// to the device-local zone when neither is available (previous behavior) or the id is bad.
export const toStoreTime = (value, tzId) => {
  const zone = tzId || _storeTz;
  if (zone) {
    try {
      return dayjs.utc(value).tz(zone);
    } catch {
      /* invalid tz id → fall through to device-local */
    }
  }
  return dayjs.utc(value).local();
};

// Back-compat: every screen that shows a stored UTC timestamp funnels through toLocal, so
// once a store timezone is configured the whole app renders in it (else device-local).
export const toLocal = (value) => toStoreTime(value);

export default dayjs;
